module.exports = __webpack_public_path__ + "static/media/languageIcon.45936af0.svg";